<template>
  <div class="personList-wrapper">
    <div class="personList-txt">文案说明</div>
    <div class="personList-item" @click="toBaseInfo(1)">
      <p class="title">基本信息</p>
      <p class="content">
        为支持您创建账号及登录、验证身份、配送联系，我们将在您完善账号信息、进行身份验证、下单时，收集使用您的昵称、手机号码、收货地址、证件信息及其他身份信息
      </p>
    </div>
    <div class="personList-item" @click="toBaseInfo(2)">
      <p class="title">使用过程信息</p>
      <p class="content">
        为向您提供购物车服务、展示搜索、浏览、个性化推荐服务，我们将在您使用相应的产品或服务时，收集使用您的加购信息、订单及其他记录
      </p>
    </div>
    <div class="personList-item" @click="toBaseInfo(3)">
      <p class="title">位置信息</p>
      <p class="content">
        为向您展示与位置相关的商品或服务，我们将在您授权访问位置权限并查看与位置相关的商品或服务时，收集使用您的位置信息
      </p>
    </div>
    <div class="personList-item" @click="toBaseInfo(4)">
      <p class="title">设备信息</p>
      <p class="content">
        为向您提供适配的页面展示、保障账号及交易安全，我们将在您启动APP或下单时，收集使用您的设备型号，分辨率及其他设备信息
      </p>
    </div>
  </div>
</template>
<script>
import { navBar } from '@/utils/native_interactions/native_bar'
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      navBar.setTitle({
        text: '个人信息清单'
      })
    })
  },
  methods: {
    toBaseInfo(type) {
      this.$router.push({
        name: 'personListInfo',
        query: {
          type
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.personList {
  &-wrapper {
    height: 100vh;

    padding: 0.24rem;
    overflow: hidden;

    background-color: #f5f5f5;
    overflow-y: auto;
    > * {
      margin-bottom: 0.24rem;
    }
  }
  &-txt {
    font-size: 0.28rem;
    color: #666;
  }
  &-item {
    padding: 0.24rem;

    background-color: #fff;
    border-radius: 0.24rem;
    .title {
      display: inline-block;

      position: relative;

      margin-bottom: 0.2rem;

      background-image: url('../../images/person_list/greenbar_short.png');
      background-repeat: no-repeat;
      background-position: bottom;
      background-size: contain;

      font-size: 0.36rem;
      line-height: 0.4rem;
      font-weight: 600;
      color: #222;
      img {
        position: absolute;
        top: 0.28rem;
        left: 0;

        width: 100%;
      }
    }
    .content {
      font-size: 0.28rem;
      line-height: 0.44rem;
      color: #888;
    }
  }
}
</style>
